module.exports = __webpack_public_path__ + "img/bookmark-check.397d7f53.svg";